import React, { Component } from 'react';
import PropTypes from 'prop-types';

import itemAttributes from '../../../../config/itemDataAttributes';
import watchAttributes from '../../../../config/watchDataAttributes';
import carAttributes from '../../../../config/carDataAttributes';
import comicAttributes from '../../../../config/comicDataAttributes';
import otherAttributes from '../../../../config/otherDataAttributes';
import ArtAttributes from '../../../../config/artDataAttributes';
import CoinAttributes from '../../../../config/coinDataAttributes';
import StampAttributes from '../../../../config/stampDataAttributes';
import AntiqueAttributes from '../../../../config/antiqueDataAttributes';
import BookAttributes from '../../../../config/bookDataAttributes';
import CameraAttributes from '../../../../config/cameraDataAttributes';
import FirearmAttributes from '../../../../config/firearmDataAttributes';
import HandbagAttributes from '../../../../config/handbagDataAttributes';
import JewelryAttributes from '../../../../config/jewelryDataAttributes';
import ToyAttributes from '../../../../config/toyDataAttributes';
import SportsCardAttributes from '../../../../config/sportsCardDataAttributes';
import VinylRecordAttributes from '../../../../config/vinylRecordDataAttributes';
import HistoricalMemAttributes from '../../../../config/historicalMemorabiliaDataAttributes';
import MovieMemAttributes from '../../../../config/movieMemorabiliaDataAttributes';
import MusicalInstrumentAttributes from '../../../../config/musicalInstrumentDataAttributes';
import MusicMemAttributes from '../../../../config/musicMemorabiliaDataAttributes';
import SportsMemAttributes from '../../../../config/sportsMemorabiliaDataAttributes';
import WineAttributes from '../../../../config/wineDataAttributes';
import Item from '../../../../models/Item';
import formPropType from '../../../common/types/formPropsType';

import EditableLineItem from './EditableLineItem';

class DetailLineItems extends Component {
  render() {
    const {
      item, properties, formProps, startInEditMode,
    } = this.props;

    return properties.map((property) => {
      let attributes;
      let section;

      if (property === 'inventory_no') {
        attributes = itemAttributes;
        section = 'itemData';
      } else if (property.substr(0, 3) === 'co_') {
        attributes = CoinAttributes;
        section = 'specificData';
      } else if (property.substr(0, 6) === 'sport_') {
        attributes = SportsMemAttributes;
        section = 'specificData';
      } else if (property.substr(0, 10) === 'insurance_') {
        attributes = itemAttributes;
        section = 'itemData';
      } else if (property.substr(0, 17) === 'specific_location') {
        attributes = itemAttributes;
        section = 'itemData';
      } else {
        switch (property.substr(0, 2)) {
          case 'w_':
            attributes = watchAttributes;
            section = 'specificData';
            break;

          case 's_':
            attributes = StampAttributes;
            section = 'specificData';
            break;

          case 'c_':
            attributes = carAttributes;
            section = 'specificData';
            break;

          case 'o_':
            attributes = otherAttributes;
            section = 'specificData';
            break;

          case 'co':
            attributes = comicAttributes;
            section = 'specificData';
            break;

          case 'ar':
            attributes = ArtAttributes;
            section = 'specificData';
            break;

          case 'an':
            attributes = AntiqueAttributes;
            section = 'specificData';
            break;

          case 'bo':
            attributes = BookAttributes;
            section = 'specificData';
            break;

          case 'ca':
            attributes = CameraAttributes;
            section = 'specificData';
            break;

          case 'fi':
            attributes = FirearmAttributes;
            section = 'specificData';
            break;

          case 'ha':
            attributes = HandbagAttributes;
            section = 'specificData';
            break;

          case 'je':
            attributes = JewelryAttributes;
            section = 'specificData';
            break;

          case 'sp':
            attributes = SportsCardAttributes;
            section = 'specificData';
            break;

          case 'to':
            attributes = ToyAttributes;
            section = 'specificData';
            break;

          case 're':
            attributes = VinylRecordAttributes;
            section = 'specificData';
            break;

          case 'wi':
            attributes = WineAttributes;
            section = 'specificData';
            break;

          case 'hi':
            attributes = HistoricalMemAttributes;
            section = 'specificData';
            break;

          case 'mo':
            attributes = MovieMemAttributes;
            section = 'specificData';
            break;

          case 'mu':
            attributes = MusicMemAttributes;
            section = 'specificData';
            break;

          case 'in':
            attributes = MusicalInstrumentAttributes;
            section = 'specificData';
            break;

          default:
            attributes = itemAttributes;
            section = 'itemData';
        }
      }

      const value = item[section][property] ? item[section][property] : '';
      let dataAttr = attributes[property];
      const propertyPath = `${section}.${property}`;

      if (!dataAttr) {
        dataAttr = itemAttributes[property];
      }

      if (!dataAttr) {
        throw new Error(`Unknown attribute: ${property}`);
      }

      return (
        <EditableLineItem
          label={dataAttr.friendly}
          value={value}
          attribute={dataAttr}
          propertyPath={propertyPath}
          key={propertyPath}
          formProps={formProps}
          startInEditMode={startInEditMode}
        />
      );
    });
  }
}

DetailLineItems.propTypes = {
  item: PropTypes.instanceOf(Item).isRequired,
  properties: PropTypes.arrayOf(PropTypes.string).isRequired,
  formProps: formPropType.isRequired,
  startInEditMode: PropTypes.bool,
};

DetailLineItems.defaultProps = {
  startInEditMode: false,
};

export default DetailLineItems;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/DetailLineItems.jsx